import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Input,
  output,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';

export interface SortCriterion {
  value: string;
  name: string;
}

@Component({
  selector: 'fz-sort-by',
  standalone: true,
  imports: [
    MatButton,
    MatIcon,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatTooltip,
  ],
  templateUrl: './sort-by.html',
  styleUrls: ['./sort-by.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'fz-sort-by',
  },
})
export class SortBy {
  @Input() label = 'Sort by';

  @Input()
  set initial(value: string) {
    this.sortBy.set(value);
  }

  @Input()
  appearance: 'icon' | 'default' = 'default';

  criteria = input.required<Record<string, string>>();

  sortChange = output<{ name: string; value: string }>();

  sortBy = signal('');

  sortByLabel = computed(() => {
    const criteria = this.criteria();
    return criteria[this.sortBy()] || null;
  });

  sortOrientation = signal<'asc' | 'desc'>('asc');

  items = computed(() => {
    return Object.entries(this.criteria()).map(
      ([name, value]) =>
        ({
          name,
          value,
        }) as SortCriterion,
    );
  });

  onSortChange(item: SortCriterion): void {
    this.sortBy.set(item.name);
    this.sortChange.emit(item);
  }

  onSortOrientationChange(): void {
    this.sortOrientation.set(this.sortOrientation() === 'asc' ? 'desc' : 'asc');
  }
}
